import axios from 'axios';
/** Services Import */
import CryptoJS from 'crypto-js';
import { UAParser } from 'ua-parser-js';
import Store from '../../Store/Store';
import { logApiUrl } from './logApiUrl';
import {
  attachButtonRequest,
  releaseButtonRequest,
} from '../../Components/MUIs/ButtonGuard';

axios.interceptors.request.use(attachButtonRequest);
axios.interceptors.response.use(
  (response) => {
    releaseButtonRequest(response.config);
    return response;
  },
  (error) => {
    releaseButtonRequest(error.config);
    return Promise.reject(error);
  }
);

const Commons = {
  // 현재 화면의 너비와 높이 반환 함수

  Dimentions: () => {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  },

  // 모바일인지 Check, mobile => true
  IsMobile: () => {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    );
  },
  // 0 : 테블릿 1: 모바일 2: 웹
  DeviceCheck: () => {
    const ua = navigator.userAgent;

    const isTablet =
      /iPad|Tablet|PlayBook|Silk/i.test(ua) ||
      (/Android/i.test(ua) && !/Mobile/i.test(ua)); // Android Tablet 구분

    const isMobile =
      /iPhone|iPod|Android.*Mobile|Windows Phone|BlackBerry/i.test(ua);

    if (isTablet) return '0';
    if (isMobile) return '1';
    return '2';
  },

  // Android 인지 IOS 인지 구분
  CheckMobileDevice: () => {
    let varUA = navigator.userAgent.toLowerCase(); //userAgent 값 얻기

    if (varUA.indexOf('android') > -1) {
      //안드로이드
      return 'android';
    } else if (
      varUA.indexOf('iphone') > -1 ||
      varUA.indexOf('ipad') > -1 ||
      varUA.indexOf('ipod') > -1
    ) {
      //IOS
      return 'ios';
    } else {
      //아이폰, 안드로이드 외 (web 화면 등)
      return 'other';
    }
  },

  // browser 구분
  CheckBrowser: () => {
    let ua = navigator.userAgent.toLowerCase();
    const { browser, os, device } = UAParser(ua);
    // alert(browser.name);
    if (browser.name.indexOf('Edge') > -1) {
      return 'msEdge'; // MS 엣지
    } else if (browser.name.indexOf('edg/') > -1) {
      return 'edge'; // 크롬 기반 엣지
    } else if (browser.name.indexOf('Opera') > -1) {
      return 'opera'; // 오페라
    } else if (
      browser.name.indexOf('Chrome') > -1 ||
      browser.name.indexOf('chrome') > -1
    ) {
      return 'chrome'; // 크롬
    } else if (
      browser.name.indexOf('Internet Explorer') > -1 ||
      browser.name.indexOf('IE') > -1
    ) {
      return 'msIe'; // 익스플로러
    } else if (browser.name.indexOf('Firefox') > -1) {
      return 'firefox'; // 파이어 폭스
    } else if (browser.name.indexOf('Samsung Internet') > -1) {
      return 'samsung'; // 삼성인터넷
    } else if (browser.name.indexOf('Safari') > -1) {
      return 'safari'; // 사파리
    } else {
      return 'other'; // 기타
    }
  },

  // String change function
  ChangeString: (_data, _type = 'trim') => {
    if (_data.lenght < 1) {
      return '';
    }

    const data = _data.toString();

    switch (_type) {
      case 'trim':
        return data.trim();
      case 'lTrim':
        return data.trimStart();
      case 'rTrim':
        return data.trimEnd();
      case 'toInt':
        if (!parseInt(data)) {
          return 0;
        } else {
          return parseInt(data);
        }
      case 'toFloat':
        if (!parseFloat(data)) {
          return 0;
        } else {
          return parseFloat(data);
        }
      case 'upper':
        return data.toUpperCase();
      case 'lower':
        return data.toLowerCase();
    }
  },

  // Grid insert rows number
  InsertNumber: (_arr = []) => {
    const arr = Array.isArray(_arr) ? _arr : [];
    return arr.map((item, index) => ({ ...item, no: index + 1 }));
  },

  // 칼럼 'i' 기준으로 중복 제거
  Deduplication: (_arr = []) => {
    let result = _arr.reverse().filter((item, index) => {
      return (
        _arr.findIndex((item1, index1) => {
          return item.i === item1.i;
        }) === index
      );
    });

    return result.reverse();
  },

  // SHA256 암호화 함수
  Sha256Encrypt: (text) => {
    const hash = CryptoJS.SHA256(text);
    return CryptoJS.enc.Base64.stringify(hash);
  },

  // AES256 암호화 함수
  EncryptAES: (_text) => {
    const cipher = CryptoJS.AES.encrypt(
      _text,
      CryptoJS.enc.Utf8.parse(
        process.env.REACT_APP_ENCRYPT_KEY.padEnd(32, ' ')
      ),
      {
        iv: CryptoJS.enc.Utf8.parse(''),
        padding: CryptoJS.pad.Pkcs7,
        mode: CryptoJS.mode.CBC,
      }
    );
    return cipher.toString();
  },

  // AES256 복호화 함수
  DecryptoAES: (_text) => {
    const cipher = CryptoJS.AES.decrypt(
      _text,
      CryptoJS.enc.Utf8.parse(
        process.env.REACT_APP_ENCRYPT_KEY.padEnd(32, ' ')
      ),
      {
        iv: CryptoJS.enc.Utf8.parse(''),
        padding: CryptoJS.pad.Pkcs7,
        mode: CryptoJS.mode.CBC,
      }
    );
    return cipher.toString(CryptoJS.enc.Utf8);
  },

  // Local Storage get/set/remove/clear return function
  Storages: (_type, _name, _data) => {
    switch (_type) {
      case 'get':
        if (_name) {
          return JSON.parse(window.localStorage.getItem(_name));
        } else {
          return 'error';
        }
      case 'set':
        if (_name && _data) {
          window.localStorage.setItem(_name, JSON.stringify(_data));
          break;
        } else {
          return 'error';
        }
      case 'remove':
        if (_name) {
          window.localStorage.removeItem(_name);
          break;
        } else {
          return 'error';
        }
      case 'clear':
        window.localStorage.clear();
        break;
    }
  },

  //Axios get/post response function
  Axios: async (_type = 'get', _url, _params, _bodys = null) => {
    // logApiUrl('API 호출', { method: _type, url: _url });

    const state = Store.getState();
    const userInfo = state?.BaseInfo?.userInfo;

    const token = userInfo?.token ?? null;
    const userId = userInfo?.userid ?? null;

    switch (_type) {
      case 'get':
        return await axios.get(_url, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + token,
          },
          params: _params,
        });

      case 'post':
        if (_bodys === null) {
          _bodys = _params;
        }
        return await axios.post(_url, _bodys, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + token,
          },
          params: _params,
        });

      case 'post1': // 대용량 데이터 전송
        if (_bodys === null) {
          _bodys = _params;
        }
        return await axios.post(_url, _bodys, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + token,
          },
          params: !_bodys ? _params : '',
        });

      case 'file':
        if (_bodys === null) {
          _bodys = _params;
        }
        return await axios.post(_url, _bodys, {
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: 'Bearer ' + token,
          },
          params: !_bodys ? _params : '',
        });

      case 'fileDown':
        if (_bodys === null) {
          _bodys = _params;
        }
        return await axios.post(_url, _bodys, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + token,
          },
          responseType: 'blob',
          params: _params,
        });

      case 'chunk':
        if (_bodys === null) {
          _bodys = _params;
        }

        return await axios.post(_url, _bodys, {
          headers: {
            'Content-Type': `multipart/form-data`,
            Authorization: 'Bearer ' + token,
          },
          params: !_bodys ? _params : '',
          timeout: 0,
          onUploadProgress: (progressEvent) => {
            const percentCompleted = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            );
            console.log(`Chunk upload progress: ${percentCompleted}%`);
          },
        });

      case 'report': // ✅ 레포트 서버 PDF 요청
        if (_bodys === null) {
          _bodys = _params;
        }
        return await axios.post(_url, _bodys, {
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + token,
          },
          responseType: 'blob',
          params: !_bodys ? _params : '',
        });

      case 'login':
        return await axios.post(_url, _params, {
          Headers: {
            headers: { 'Content-Type': 'application/json' },
          },
          body: _params,
        });

      case 'logout':
        window.localStorage.setItem(
          'auth',
          JSON.stringify({
            auth: false,
          })
        );

        return true;
      case 'file2':
        if (_bodys === null) {
          _bodys = _params;
        }

        return await axios.post(_url, _bodys, {
          headers: {
            'Content-Type': `multipart/form-data`,
          },
          params: !_bodys ? _params : '',
        });
    }
  },

  // Change Date String format
  ChangeDateFormat: (_date, _type = 1) => {
    if (_date.lenght < 1) {
      return '';
    }

    switch (_type) {
      case 1:
        if (typeof _date === 'string' && _date.length === 14) {
          return (
            _date.slice(0, 4) +
            '-' +
            _date.slice(4, 6) +
            '-' +
            _date.slice(6, 8) +
            ' ' +
            _date.slice(8, 10) +
            ':' +
            _date.slice(10, 12) +
            ':' +
            _date.slice(12, 14)
          );
        } else if (typeof _date === 'string' && _date.length === 8) {
          return (
            _date.slice(0, 4) +
            '-' +
            _date.slice(4, 6) +
            '-' +
            _date.slice(6, 8)
          );
        } else {
          return _date;
        }

      case 2:
        return (
          _date.getFullYear().toString() +
          '-' +
          _date.getMonth().toString() +
          '-' +
          _date.getDate().toString() +
          ' ' +
          _date.getHours().toString() +
          ':' +
          _date.getMinutes().toString() +
          ':' +
          _date.getSeconds().toString()
        );

      case 3:
        return (
          _date.getFullYear().toString() +
          '-' +
          _date.getMonth().toString() +
          '-' +
          _date.getDate().toString()
        );
    }
  },

  // URL 인코딩 처리 함수 (파일명만 인코딩)
  EncodeUrl: (url) => {
    if (!url || typeof url !== 'string') return ''; // 또는 적절한 fallback
    const parts = url.split('/');
    const fileName = parts.pop(); // 파일 이름 분리
    const encodedFileName = encodeURIComponent(fileName);
    return [...parts, encodedFileName].join('/');
  },
};

export default Commons;
